/*------------------------add reception-------------------------*/
import {
    SearchFullNamePopup,
    SearchListCase,
    ListInfoDocumentDialog,
    ListGroupTypeReception,
    AttachmentsFilePopup,
    AddReception,
    ThemThanhVienDoan,
    ThongTinDoiTuongBiKhieuTo,
    ThongTinDon,
    ThongTinNguoiDungDon,
} from './add-reception';
/*------------------------list reception-------------------------*/
import {
    SearchReception,
    ListReception
} from './list-reception';
/*------------------------detail reception-------------------------*/
import {
    DetailReception
} from './detail-reception';

import ThongTinUyQuyen from './ThongTinUyQuyen.jsx';
import ThongTinCaNhan from './ThongTinCaNhan.jsx';
import ThongTinTiepCongDan from './ThongTinTiepCongDan.jsx';
import KetQuaTiepCongDan from './KetQuaTiepCongDan.jsx';
import CanBoNhanKetQuaKiemTraDeXuat from './CanBoNhanKetQuaKiemTraDeXuat.jsx';
import TinhTrangDon from './TinhTrangDon.jsx';

export {
    SearchFullNamePopup,
    SearchListCase,
    ListInfoDocumentDialog,
    SearchReception,
    ListGroupTypeReception,
    AttachmentsFilePopup,
    AddReception,
    ListReception,
    DetailReception,
    ThemThanhVienDoan,
    ThongTinDoiTuongBiKhieuTo,
    ThongTinDon,
    ThongTinNguoiDungDon,
    ThongTinUyQuyen,
    ThongTinCaNhan,
    ThongTinTiepCongDan,
    KetQuaTiepCongDan,
    CanBoNhanKetQuaKiemTraDeXuat,
    TinhTrangDon
};



// WEBPACK FOOTER //
// ./src/components/modules/reception/index.js